export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11395.2d02251a.jpg";